import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconLink from '@src/assets/images/common/icon/editor/SvgIconLink';
import React from 'react';

interface LinkButtonProps {
  isActive: boolean;
  refreshActiveState: () => void;
  onOpenLinkAddModal: () => void;
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  isActive,
  refreshActiveState,
  onOpenLinkAddModal,
}) => {
  const activeHoverColor = brandColors['500'] || '#2B5CDD';
  const defaultIconColor = 'currentColor';

  return (
    <button
      onClick={() => {
        onOpenLinkAddModal();
        setTimeout(refreshActiveState, 0);
      }}
      className={`toolbar-button ${isActive ? 'active' : ''}`}
      title='リンクを挿入'
      type='button'
    >
      <SvgIconLink color={isActive ? activeHoverColor : defaultIconColor} />
    </button>
  );
};
